var _animateTransform, _animateTransform2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSpinning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.841927 37.968513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57.610061,-104.80183)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 95.210653,137.38557 c 0,0 9.852167,-3.3399 18.596997,-3.3399 8.74482,0 17.50572,3.15404 18.20912,3.45021 0.7034,0.29616 0.48128,1.14764 -0.14808,1.18467 -0.62936,0.037 -72.005841,0.28438 -72.6762,0.35142 -0.670356,0.067 -0.837943,-0.87147 -0.167587,-1.17313 0.670356,-0.30166 7.776136,-3.82103 18.501841,-3.85455 10.725708,-0.0335 17.683909,3.38128 17.683909,3.38128 z",
    style: {
      fill: "#00aeef",
      fillOpacity: 1,
      stroke: "none"
    },
    id: "path931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 58.719246,140.77682 c 0,0 71.640604,-0.21535 72.744904,-0.21535 1.1043,0 1.36723,1.78791 0.21034,1.78791 -1.15688,0 -71.294923,0.41991 -72.831136,0.42069 -1.736307,0.0274 -1.510274,-1.98824 -0.124108,-1.99325 z",
    style: {
      fill: "#00aeef",
      fillOpacity: 1,
      stroke: "none"
    },
    id: "path933"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.26458333,0,0,0.26458333,57.610061,104.80183)",
    d: "M 70.640625,0.00195313 C 15.958765,-0.35989717 4.6246904,37.618172 4.7304688,56.908203 4.8396971,76.820493 16.642714,110.31641 50.455078,110.31641 c 33.812372,0 42.921875,-28.740238 42.921875,-28.740238 0,0 -16.302084,19.119488 -42.507812,20.029298 C 33.303745,101.30311 19.44807,88.589529 17.90625,69.191406 16.62019,53.011249 28.308715,36.319686 43.283203,26.671875 c 14.974405,-9.647811 44.343902,-15.880461 69.212887,4.494141 24.86901,20.374601 29.61719,91.984374 29.61719,91.984374 0.1101,-13.0083 0.14997,-22.88033 0.17188,-31.144531 0.0219,8.264201 -0.28277,18.136991 -0.17268,31.145281 0,0 5.09275,-71.610523 29.96174,-91.985124 24.86899,-20.374602 54.24043,-14.141952 69.21484,-4.494141 14.97449,9.647811 26.66302,26.339374 25.37696,42.519531 -1.54182,19.398123 -15.39946,32.111704 -32.96485,32.414064 -26.20573,-0.90981 -42.50781,-20.029298 -42.50781,-20.029298 0,0 9.11146,28.740238 42.92383,28.740238 33.81237,0 45.61538,-33.495917 45.72461,-53.408207 0.10919,-19.91229 -11.97089,-59.7360656 -71.33789,-56.74804675 -59.367,2.98801885 -66.21875,70.19531275 -66.21875,70.19531275 0,0 -6.84979,-67.2072939 -66.216801,-70.19531275 C 74.213141,0.06678066 72.404556,0.01362572 70.640625,0.00195313 Z",
    style: {
      fill: "#00aeef",
      fillOpacity: 1,
      stroke: "none"
    },
    id: "path929-4-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 119.33565,110.01276 c -0.63151,-3e-5 -1.26203,0.0499 -1.88567,0.14935 1.55598,0.43755 6.02446,0.49065 9.04845,4.93292 2.02141,2.96945 2.5521,8.17372 -0.65427,12.30341 -3.88078,6.15295 -12.606,2.36039 -14.3411,0.16726 -1.7351,-2.19312 -2.53082,-7.10072 1.13791,-9.4263 3.66873,-2.32558 8.28908,0.71049 8.49716,2.93005 0.2079,2.21757 -1.07306,5.62367 -4.43125,4.76767 -3.3582,-0.85599 -2.40262,-4.784 -2.02004,-5.20692 0.27882,-0.30822 -0.0753,-0.7048 -0.40462,-0.39481 -1.10747,1.0426 -1.42298,3.96497 0.2036,5.6932 1.62658,1.72824 5.38798,1.21973 7.01456,-0.5085 1.62658,-1.72824 2.10366,-5.36619 -0.44597,-8.02225 -2.54963,-2.65606 -6.96926,-3.2347 -10.49393,-0.71623 -1.99998,1.42904 -2.88727,3.88551 -3.17035,6.07818 0.40946,6.29633 5.63589,11.19379 11.94552,11.19363 3.27577,-3e-5 6.40841,-1.34251 8.66769,-3.7145 1.60464,-1.87767 2.61968,-4.20823 3.16312,-6.43372 0.0929,-0.60293 0.13951,-1.21207 0.13952,-1.82211 -7e-5,-6.611 -5.35932,-11.97026 -11.97033,-11.97033 z",
    style: {
      fill: "#00aeef",
      fillOpacity: 1,
      stroke: "none"
    },
    id: "path929-4-6-4"
  }, _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "0 118.8 121.8",
    to: "360 118.8 121.8",
    dur: ".7s",
    additive: "sum",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path929-4-6-4-7",
    style: {
      fill: "#00aeef",
      fillOpacity: 1,
      stroke: "none"
    },
    d: "m 71.177491,110.01276 c 0.631513,-4e-5 1.262038,0.0499 1.885672,0.14934 -1.555975,0.43755 -6.024459,0.49066 -9.048449,4.93292 -2.02141,2.96945 -2.5521,8.17373 0.65427,12.30342 3.88078,6.15295 12.606001,2.36038 14.341102,0.16725 1.735101,-2.19312 2.530816,-7.10071 -1.137915,-9.42629 -3.668727,-2.32558 -8.289077,0.71049 -8.497157,2.93005 -0.2079,2.21757 1.073065,5.62367 4.431255,4.76767 3.358193,-0.85599 2.402612,-4.784 2.020033,-5.20692 -0.278821,-0.30822 0.07534,-0.7048 0.404627,-0.39481 1.107469,1.0426 1.422974,3.96496 -0.203605,5.69319 -1.626581,1.72824 -5.38798,1.21974 -7.01456,-0.50849 -1.62658,-1.72824 -2.10366,-5.36619 0.44597,-8.02225 2.549628,-2.65606 6.969262,-3.23471 10.49393,-0.71624 1.999985,1.42904 2.887276,3.88552 3.170351,6.07819 -0.409463,6.29633 -5.635888,11.19379 -11.945524,11.19363 -3.275767,-3e-5 -6.408407,-1.34251 -8.667687,-3.7145 -1.60464,-1.87767 -2.61968,-4.20823 -3.16312,-6.43372 -0.0929,-0.60293 -0.13951,-1.21207 -0.13952,-1.82211 7e-5,-6.611 5.35933,-11.97026 11.970327,-11.97033 z"
  }, _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "360 71.4 121.8",
    to: "0 71.4 121.8",
    dur: ".9s",
    additive: "sum",
    repeatCount: "indefinite"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSpinning);
export default __webpack_public_path__ + "static/media/logoSpinning.11d17c681d57acd20a37d4cab7003e35.svg";
export { ForwardRef as ReactComponent };